<template>
  <div
    class="flex align-items-center"
    style="height:60px"
  >
    <img
      alt="Daughtridge Sales logo"
      src="/images/Daughtridge-Sales-Color-NoSpacing.svg"
      height="30"
    >
  </div>
</template>
